<template>
  <div class="container thank-you-container">
    <div class="thank-you-message">
      <no-drag-image class="logo" src="@/assets/logo-round-white.png" />
      <p class="animate__animated" :class="wobble ? 'animate__tada' : ''" @animationend="onWobbleDone">
        {{ $t('end.thankYou') }}
      </p>
    </div>
  </div>
</template>

<script>


import { mapState } from 'pinia';
import { useSurveyStore } from '@/store';
import NoDragImage from '@/components/common/NoDragImage';

export default {
  name: 'ThankYouView',
  components: {
    NoDragImage,
  },
  computed: {
    ...mapState(useSurveyStore, [
      'submissionToken',
    ]),
  },
  data() {
    return {
      wobble: false,
      wobbleTimer: null,
    };
  },
  mounted() {
    useSurveyStore().setBackground('blue');

    if (!this.submissionToken) {
      // Something is wrong if we don't have a submission token

      // this.$router.push('/');

      // return;
    }

    this.startWobbleTimer();
  },
  methods: {
    onWobbleDone() {
      this.startWobbleTimer();
    },
    stopWobbleTimer() {
      if (this.wobbleTimer) {
        clearTimeout(this.wobbleTimer);

        this.wobbleTimer = null;
      }

      this.wobble = false;
    },
    startWobbleTimer() {
      this.stopWobbleTimer();

      this.wobbleTimer = setTimeout(() => {
        this.stopWobbleTimer();

        this.wobble = true;
      }, 5000);
    },
  },
};
</script>

<style lang="scss" scoped>
.thank-you-container {
  .thank-you-message {
    font-size: 22pt;
    position: fixed;
    color: white;
    font-weight: bold;
    text-align: center;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: auto;
    height: auto;

    img {
      max-width: 80%;
      max-height: 80%;
      margin-bottom: 50px;
    }
  }
}

</style>
